import { t } from 'i18next';
import { isErrorStatus, isLoadingStatus, useResource } from 'json-api-hooks';
import React from 'react';

import FormFooterRight from '../components/./Form/FooterRight';
import Card from '../components/Card';
import CardContent from '../components/Card/CardContent';
import ErrorCard from '../components/Error/ErrorCard';
import FormFooter from '../components/Form/FormFooter';
import Heading from '../components/Heading';
import HeadingContext from '../components/Heading/HeadingContext';
import Image from '../components/Image';
import { LoadingCard } from '../components/Loading';
import Markdown from '../components/Markdown';
import { ModalProps } from '../components/Modal/ModalContextProvider';

const BadgeModal = ({ handleClose, id }: ModalProps<{ id: string }>) => {
  const [badge, status] = useResource({ id, type: 'badges' });

  if (isLoadingStatus(status)) {
    return <LoadingCard />;
  }

  if (isErrorStatus(status) || !badge) {
    return <ErrorCard />;
  }

  return (
    <Card>
      <HeadingContext>
        <CardContent centered style={{ maxWidth: '25em' }}>
          <Heading>{badge.attributes.title}</Heading>
          <Image
            style={{
              marginBottom: '1em',
              maxWidth: '100%',
              width: '300px',
            }}
            url={badge.attributes.image}
          />
          <Markdown text={badge.attributes.description} />
          <Markdown text={badge.attributes.text} />
        </CardContent>
      </HeadingContext>
      <FormFooter>
        <FormFooterRight submitLabel={t('badge.continue')} onSubmit={handleClose} />
      </FormFooter>
    </Card>
  );
};

export default BadgeModal;
